<template>

<div>
   <h2>
    Page not found! Maybe view our Home Page
    <router-link to="/Home">Click Here</router-link>
  </h2>

</div>
 
</template>

<script>

export default {
  
}
</script>

<style scoped>

.class-name{
height:100vh;
width: 100%;
 position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);


}
</style>